export default [
  {
    name: 'Райффайзен',
    logo: require('@/assets/partners/raif.svg'),
    href: '#'
  }
]
